import { createContext, useContext, type ReactNode } from "react";

// STUB — CHG-1167 scaffold. Real theming (per-org branding overrides applied
// to :root via CSS custom properties) lands ε CHG-1164 (brand variants admin).
//
// The base token system is ALWAYS applied via src/styles/tokens.css — this
// context only handles per-org overrides on top.

export interface ThemeContextValue {
  themeId: string;
  applyOverrides: (overrides: Record<string, string>) => void;
}

const ThemeContext = createContext<ThemeContextValue>({
  themeId: "default",
  applyOverrides: () => undefined,
});

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeContext.Provider value={{ themeId: "default", applyOverrides: () => undefined }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme(): ThemeContextValue {
  return useContext(ThemeContext);
}
